import React from "react";
import WelcomeBanner from "./welcome-banner";

const RootUserDashboard = (props) => {
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <WelcomeBanner />

      <h1>Hello from Superuser dashboard</h1>
    </div>
  );
};

export default RootUserDashboard;
